// extracted by mini-css-extract-plugin
export var closeButton = "_jx-1";
export var closeX = "_jx-3";
export var container = "_jx-0";
export var image = "_jx-2";